import { selectors as AccountSelectors } from 'app/entities/Account';
import { selectors as ProfileSelectors } from 'app/entities/Profile';

export const getSwitchesFromState = state => {
  const currentAccount = AccountSelectors.all.currentAccount(state);
  const currentProfile = ProfileSelectors.all.currentProfile(state);

  const accountSwitches =
    currentAccount && currentAccount.data && currentAccount.data.switches
      ? currentAccount.data.switches
      : {};
  const profileSwitches =
    currentProfile && currentProfile.data && currentProfile.data.switches
      ? currentProfile.data.switches
      : {};

  return {
    ...accountSwitches,
    ...profileSwitches,
  };
};
